import { Paper, TableContainer, Table, TableHead, TableRow, TableCell, TableBody, Box, TablePagination, Button } from '@mui/material';
import { useState } from 'react';
import { useTranslation } from "react-i18next";
import { useSelector } from 'react-redux';
import { selectCurrentToken } from 'features/auth/authSlice';
import { deepPurple, grey } from '@mui/material/colors';
import UpdateAmbassadorLevelModal from './UpdateAmbassadorLevelModal';

function StickyHeadTable({ ambassadorLevels, fetchAmbassadorLevel }) {
    const { t } = useTranslation();
    const token = useSelector(selectCurrentToken);

    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(100);

    const [selectedCustomerRow, setSelectedCustomerRow] = useState(null);
    
    const [updateAmbassadorLevelModalOpen, setUpdateAmbassadorLevelModalOpen] = useState(false);

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(+event.target.value);
        setPage(0);
    };
    
    const openUpdateAmbassadorLevelModal = (row) => {
        setSelectedCustomerRow(row);
        setUpdateAmbassadorLevelModalOpen(true);
    };

    return (
        <>
            <Paper sx={{ width: '100%', overflow: 'hidden', marginTop: '50px' }}>
                <TableContainer sx={{ height: '100vh' }}>
                    <Table stickyHeader aria-label="sticky table">
                        <TableHead>
                            <TableRow>
                                <TableCell key="vipLevel" style={{ minWidth: 170 }}>{t("ambassadorLevel.vipLevel")}</TableCell>
                                <TableCell key="task" style={{ minWidth: 170 }}>{t("ambassadorLevel.task")}</TableCell>
                                <TableCell key="withdrawalLimitation" style={{ minWidth: 170 }}>{t("ambassadorLevel.withdrawalLimitation")}</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {ambassadorLevels.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row) => {
                                return (
                                    <TableRow hover role="checkbox" tabIndex={-1} key={row.code}>
                                        <TableCell key='vipLevel' style={{fontSize: "12px"}}>
                                            <span style={{fontWeight: 'bolder'}}>{row.ambassadorLevelName}</span> <br/>
                                        </TableCell>
                                        <TableCell key='task' style={{fontSize: "12px"}}>
                                            {t("ambassadorLevel.minAmount")}: {row.cashBonusGiven}<br/>
                                            {t("ambassadorLevel.taskCount")}: {row.eachSetTaskNumber}<br/>
                                            {row.totalTaskSet}{t("ambassadorLevel.taskSet")}<br/>
                                            {t("ambassadorLevel.comissionPercentage")}: {row.incentivePercentage}<br/>
                                            {t("ambassadorLevel.comboComissionPercentage")}: {row.comboTaskIncentivePercentage}<br/>
                                            {t("ambassadorLevel.productRange")}: {row.taskPriceRangeFrom}% {t("ambassadorLevel.productRange")} {row.taskPriceRangeTo}%<br/>
                                        </TableCell>
                                        <TableCell key='withdrawalLimitation' style={{fontSize: "12px"}}>
                                            {t("ambassadorLevel.minWithdrawalAmount")}: {row.minWithdrawalAmount}<br/>
                                            {t("ambassadorLevel.maxWithdrawalAmount")}: {row.maxWithdrawalAmount}<br/>
                                            {t("ambassadorLevel.completedTaskPerDayToWithdraw")}: {row.requiredTaskCountToWithdraw}<br/>
                                            {t("ambassadorLevel.withdrawalFees")}: {row.withdrawalFees}%<br/>
                                        </TableCell>
                                        <TableCell key='action' style={{fontSize: "12px"}}>
                                            <Button
                                                onClick={() => openUpdateAmbassadorLevelModal(row)}
                                                variant="contained"
                                                style={{
                                                    border: 'none',
                                                    backgroundColor: deepPurple[500],
                                                    width: 'fit-content',
                                                    height: 'fit-content',
                                                    color: 'white',
                                                    padding: '6px 8px',
                                                    '&:hover': {
                                                        color: deepPurple[500],
                                                        backgroundColor: 'white!'
                                                    },
                                                    fontSize: '12px'
                                                }}
                                            >
                                                {t("ambassadorLevel.edit")}
                                            </Button>
                                        </TableCell>
                                    </TableRow>
                                );
                            })}
                        </TableBody>
                    </Table>
                </TableContainer>
                <TablePagination
                    rowsPerPageOptions={[10, 25, 100]}
                    component="div"
                    count={ambassadorLevels.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                />
            </Paper>
                
            {selectedCustomerRow && (
                <UpdateAmbassadorLevelModal
                    updateAmbassadorLevelModalOpen={updateAmbassadorLevelModalOpen}
                    setUpdateAmbassadorLevelModalOpen={setUpdateAmbassadorLevelModalOpen}
                    ambassadorLevelRow={selectedCustomerRow}
                    fetchAmbassadorLevels={fetchAmbassadorLevel}
                />
            )}
        </>
    );
}

export default StickyHeadTable;
